import { LiveblocksProvider, RoomProvider } from "@liveblocks/react"
import type { PropsWithChildren } from "react"

import { useCollaborationRoomFlag } from "../../app/integrations/AmplitudeExperiments"
import { getRepositoryName } from "../../app/routing"
import { useExistingDocument } from "../DocumentProvider"

export function DocumentCollaborationRoom(props: PropsWithChildren) {
  const { children } = props

  const { documentId, version } = useExistingDocument()

  if (useCollaborationRoomFlag() === "off") return <>{children}</>

  const roomId = `${getRepositoryName()}/${documentId}/${version.version_id}`

  return (
    <LiveblocksProvider publicApiKey={publicApiKey}>
      <RoomProvider id={roomId}>{children}</RoomProvider>
    </LiveblocksProvider>
  )
}

// This is the Editor's project DEV public key. It's used while we experiment with Liveblocks.
// The correct way to use Liveblocks in prod is with an auth service using the secret.
// https://liveblocks.io/dashboard/-giWz9kyVyYjbiwTMM16L/projects/66c73d8e66954bebfd3ea5f5/apikeys
const publicApiKey =
  "pk_dev_PkKSy--PPNnp37fS7qRS07uKrL0xUhVYfvoogDFukK_uL6zPTHYtq54KQqETTjmU"
